import Cookies from 'js-cookie';

export const getJwt=()=>{
    return Cookies.get('jwt-token');
//return localStorage.getItem("jwt-token");
}